// extracted by mini-css-extract-plugin
module.exports = {"main":"RichText_main__302Ei","pdf":"RichText_pdf__ae7vv","search-fade-in":"RichText_search-fade-in__UNif8"};